export const COPY_INITIATE_FAILED = 'state.actions.copy.COPY_INITIATE_FAILED' as const;
export type CopyInitiateFailureAction = {
	type: typeof COPY_INITIATE_FAILED;
};
export const copyInitiateFailed = (): CopyInitiateFailureAction => ({
	type: COPY_INITIATE_FAILED,
});

export type Action = CopyInitiateFailureAction;
